<template>
  <div id="app">
    <v-app>
      <router-view />
      <Notifier />
      <Loader/>
    </v-app>
  </div>
</template>

<script>
import io from 'socket.io-client'
import Loader from '@/components/loader'
import Notifier from '@/components/notifier'
export default {
  name: 'App',
  components: {
    Loader,
    Notifier
  },
  data: () => ({
    //
  }),
  mounted () {
    this.$firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        user.getIdToken(true).then(token => {
          let socket = io(`${this.$url.io}`, {
            query: { token },
            forceNew: true,
            transports: [ 'websocket' ]
          })
          socket.on('connect', () => {
            console.log('Socket.io connection established')
            console.log(`Is conntected: ${socket.connected}`)
            this.$store.commit('config/update', { socket })
          })
          socket.on('disconnect', (reason) => {
            console.log('Socket.io connection closed')
            console.log(reason)
            socket.connect()
          })
          socket.on('connect_error', (error) => {
            console.log('Socket.io connection error')
            console.log(error)
            setTimeout(() => {
              socket.connect()
            }, 5000)
          })
          socket.on('connect_timeout', (timeout) => {
            console.log('Socket.io connection timeout')
            console.log(timeout)
            setTimeout(() => {
              socket.connect()
            }, 5000)
          })
          window.addEventListener('online', () => {
            if (!socket.connected) {
              socket.connect()
            }
          })
        })
      }
    })
  }
};
</script>

<style scoped>
#app {
  display: block;
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: transparent;
}
.tooltip {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  background: rgba(33, 37, 41, .9);
  border-radius: 4px;
  font-size: 1.2rem;
  color: #FFF;
  padding: .5em 1em;
  font-weight: normal;
  z-index: 10;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgba(33, 37, 41, .9);
}
.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
</style>